import { c as _c } from "react/compiler-runtime";
import React from "react";
import style from "./PageHeader.module.scss";
import { NavLink } from "../../../shared/components/Navbar/Navbar";
import { Links, LinkType } from "../../blocks/Links/Links";
import type { SanityImageObject } from "@sanity/image-url";
import { ResponsiveImage } from "../../../shared/responsiveimage";
import { OpenWidgetButton } from "../../../shared/components/OpenWidgetButton/OpenWidgetButton";
export const PageHeader: React.FC<{
  title: string;
  inngress?: string;
  layout?: "default" | "centered" | "hero" | "coverPhoto" | "noheader";
  coverPhoto?: SanityImageObject;
  cta_type?: "link" | "navitem" | "open_widget";
  cta_label?: string;
  cta_cause_area_id?: number;
  cta_organization_id?: number;
  accent_color?: string;
  links?: (LinkType | NavLink)[];
}> = t0 => {
  const $ = _c(25);
  const {
    title,
    inngress,
    links,
    layout: t1,
    cta_type,
    cta_label,
    cta_cause_area_id,
    cta_organization_id,
    accent_color,
    coverPhoto
  } = t0;
  const layout = t1 === undefined ? "default" : t1;
  const hasmetacontent = inngress || links;
  if (layout === "noheader") {
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <div className={style.spacer} />;
      $[0] = t2;
    } else {
      t2 = $[0];
    }
    return t2;
  }
  const t2 = `${style.pageheader} ${hasmetacontent ? style.pageheadermeta : null} ${style[layout]}`;
  let t3;
  if ($[1] !== layout || $[2] !== title) {
    t3 = layout !== "coverPhoto" && title && <h1>{title}</h1>;
    $[1] = layout;
    $[2] = title;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== coverPhoto || $[5] !== layout || $[6] !== title) {
    t4 = layout === "coverPhoto" && coverPhoto && <ResponsiveImage image={coverPhoto} alt={title} layout="responsive" sizes="(min-width: 1920px) 1714px, 90vw" />;
    $[4] = coverPhoto;
    $[5] = layout;
    $[6] = title;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t3 || $[9] !== t4) {
    t5 = <div data-cy="header-container">{t3}{t4}</div>;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== accent_color || $[12] !== cta_cause_area_id || $[13] !== cta_label || $[14] !== cta_organization_id || $[15] !== cta_type || $[16] !== hasmetacontent || $[17] !== inngress || $[18] !== layout || $[19] !== links) {
    t6 = hasmetacontent ? <div>{inngress ? <p className="inngress">{inngress}</p> : null}{links ? <Links links={links} /> : null}{layout === "hero" && cta_type === "open_widget" ? <OpenWidgetButton label={cta_label} accent_color={accent_color} causeAreaId={cta_cause_area_id} organizationId={cta_organization_id} cy="hero-cta-open-widget" /> : null}</div> : null;
    $[11] = accent_color;
    $[12] = cta_cause_area_id;
    $[13] = cta_label;
    $[14] = cta_organization_id;
    $[15] = cta_type;
    $[16] = hasmetacontent;
    $[17] = inngress;
    $[18] = layout;
    $[19] = links;
    $[20] = t6;
  } else {
    t6 = $[20];
  }
  let t7;
  if ($[21] !== t2 || $[22] !== t5 || $[23] !== t6) {
    t7 = <section className={t2}>{t5}{t6}</section>;
    $[21] = t2;
    $[22] = t5;
    $[23] = t6;
    $[24] = t7;
  } else {
    t7 = $[24];
  }
  return t7;
};
export const ctaButtonStyleOverrides = {
  alignSelf: "start",
  padding: ".75rem 4rem",
  marginTop: "1rem"
};